// Initialize the wishlist functionality
let wishlistInitialized = false;

// Function to update all wishlist counters on the page
function updateWishlistCounters() {
  if (typeof wishList === 'undefined') {
    return;
  }
  
  const countElements = document.querySelectorAll("#wishlist-count");
  countElements.forEach(element => {
    element.innerHTML = wishList.length;
  });
}

// Initialize wishlist on page load
function initializeWishlist() {
  if (wishlistInitialized) return;
  
  // Make sure wishList is defined
  if (typeof wishList === 'undefined') {
    setTimeout(initializeWishlist, 100);
    return;
  }
  
  // Update counters
  updateWishlistCounters();
  
  wishlistInitialized = true;
}

// Run initialization on DOMContentLoaded and window load
document.addEventListener('DOMContentLoaded', initializeWishlist);
window.addEventListener('load', initializeWishlist);

class ProductWishlist extends HTMLElement {
  constructor() {
    super();
    this.id = this.getAttribute('data-productID');
    this.checkActiveWishlist();
    this.addEventListener('click', this.onEventWishlist.bind(this));
  }

  onEventWishlist() {
    // Ensure wishList is available
    if (typeof wishList === 'undefined') {
      wishList = [];
    }
    
    if (wishList.indexOf(this.id) > -1) {
      // Remove from wishlist
      this.classList.remove('wishlist_added');
      const index = wishList.indexOf(this.id);
      wishList.splice(index, 1);
    } else {
      // Add to wishlist
      this.classList.add('wishlist_added');
      wishList.push(this.id);
    }
    
    // Save to localStorage
    localStorage.setItem('wishList', JSON.stringify(wishList.slice(0, 20)));
    
    // Update all counters
    updateWishlistCounters();
  }

  checkActiveWishlist() {
    if (typeof wishList === 'undefined') {
      return;
    }
    
    if (wishList.indexOf(this.id) > -1) {
      this.classList.add('wishlist_added');
    } else {
      this.classList.remove('wishlist_added');
    }
  }
}

customElements.define('wish-list-icon', ProductWishlist);

class ProductWishlistTemplate extends HTMLElement {
  constructor() {
    super();
  }

  get searchQueryString() {
    if (typeof wishList === 'undefined' || !wishList.length) {
      return "";
    }
    return wishList.map((item) => "id:" + item).join(" OR ");
  }

  get sectionId() {
    return this.getAttribute("section-id");
  }

  async connectedCallback() {
    // Wait for wishList to be defined
    if (typeof wishList === 'undefined') {
      setTimeout(() => this.connectedCallback(), 100);
      return;
    }
    
    if (this.searchQueryString === "") {
      return;
    }
    
    try {
      const response = await fetch(`${window.routes.urlSearch}?type=product&q=${this.searchQueryString}&section_id=${this.sectionId}`);
      const div = document.createElement("div");
      div.innerHTML = await response.text();
      const wishlistProductsElement = div.querySelector("product-wishlist-template");
      if (wishlistProductsElement && wishlistProductsElement.hasChildNodes()) {
        this.innerHTML = wishlistProductsElement.innerHTML;
      }
    } catch (error) {
      console.error("Error loading wishlist products:", error);
    }
  }
}

customElements.define('product-wishlist-template', ProductWishlistTemplate);

// Run initialization after a short delay to ensure all scripts are loaded
setTimeout(initializeWishlist, 500);